import { AxiosPromise } from 'axios';
import { ICreateSitePageFormValues } from './types';
import { instance } from '../../../../services';

const createSite = (data: ICreateSitePageFormValues): AxiosPromise =>
  instance.post('/api/sites', data);

export default createSite;
